<template>
    <v-row>
        <input ref="fileInput" class="d-none" type="file" @change="onFileChange" :accept="mimeTypes"/>
        <span v-if="label" class="label pa-3 pb-1">{{ label }}</span>
        <v-col cols="12" class="pt-0">
            <v-sheet v-if="!previewImg" v-ripple class="container-img" :height="height" @click.stop="pickFile">
                <div>
                    <v-icon size="100" color="accent">mdi-upload</v-icon>
                    <br>
                    {{ $t('common.upload_image') }}
                </div>
            </v-sheet>
            <v-sheet v-else class="container-img with-img" :height="height" :style="`background-image: url(${previewImg})`">
                <v-btn @click.stop="onDeleteFile" color="error" icon class="button-img">
                    <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
            </v-sheet>
        </v-col>
    </v-row>
</template>

<script>
import {storageRef} from '@/utils/Firebase'
import {VInput} from "vuetify/lib/components";

export default {
    name: "KimsaUploadFile",
    extends: VInput,
    props: {
        relativePath: {
            type: String,
            default: 'files'
        },
        mimeTypes: {
            type: String,
            default: '*'
        },
        limitSize: {
            type: [String,Number],
            default: null,
        },
        previewImg: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        rules: {
            type: Array,
            default: () => [],
        },
        details: {
            type: Boolean,
            default: false,
        },
        height: {
            type: [Number, String],
            default: 270,
        }
    },
    data() {
        return {
            file: null,
            megabyte: 1048576,
        }
    },
    methods: {
        reset() {
            const vm = this
            vm.file = null
            vm.$refs.fileInput.value = null
        },
        pickFile() {
            const vm = this
            if(vm.previewImg) return;
            vm.$refs.fileInput.click()
        },
        onFileChange(evt) {
            const vm = this
            const file = evt.target.files[0]
            if(!file) return;

            if (vm.limitSize && file.size > (vm.limitSize * vm.megabyte))
                return vm.toast(`Tamaño maximo es de ${vm.limitSize}mb`, 'error')

            vm.file = file
            let imgURL = URL.createObjectURL(file);
            vm.$emit('change', {img: imgURL, name: file.name})
        },
        onDeleteFile() {
            const vm = this
            vm.reset()
            vm.$emit('change', null)
            vm.$emit('delete')
        },
        async upload() {
            const vm = this
            const file = vm.file
            if (!file) return console.log('no file selected')
            const savePath = `/${vm.currentUser.uid}/${vm.relativePath}/${vm.$moment().unix()}-${file.name}`
            let uploadTask = await storageRef.child(savePath).put(file)
            return {
                tempUrl: await uploadTask.ref.getDownloadURL(),
                savePath: savePath,
                name: file.name,
            }
        },
    }
}
</script>

<style scoped>

.label {
    font-size: 15px;
    color: #707070;
}

.container-img {
    background-color: #F9F9F9;
    border: 1px solid #C9CDD9;
    border-radius: 8px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}

.with-img {
    position: relative !important;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    cursor: default;
}

.button-img {
    position: absolute;
    top: 3%;
    right: 3%;
}

</style>